export default class TransientAuthTokenError extends Error {
	cause?: unknown;

	constructor(message: string, options?: { cause?: unknown }) {
		super(message);
		this.name = "TransientAuthTokenError";
		this.cause = options?.cause;
	}
}

export function isTransientAuthTokenError(error: unknown): error is TransientAuthTokenError {
	return error instanceof TransientAuthTokenError || (error instanceof Error && error.name === "TransientAuthTokenError");
}
